export const messages = {
  page: {
    title: {
      id: 'usefulLinks.Page.Title',
      defaultMessage: 'Useful Links',
    },
  },
};
